import {inject, NgModule} from '@angular/core';
import {provideApollo} from 'apollo-angular';
import {HttpLink} from 'apollo-angular/http';
import {InMemoryCache} from '@apollo/client/core';
import {environment} from '../environments/environment';

const uri = `${environment.apiUrl}dashboard/graphql`;

@NgModule({
  providers: [
    provideApollo(() => {
      const httpLink = inject(HttpLink);

      return {
        link: httpLink.create({ uri }),
        cache: new InMemoryCache(),
      };
    }),
  ],
})

export class GraphQLModule {}
